import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { push } from "connected-react-router";

import Modal from "../../ui/Modals/ModalWindow";
import MessageForm from "../../ui/MessageForm/MessageForm";
import Spinner from "../../ui/Spinner/Spinner";
import RequireAuth from "../../layout/HOC/require-auth";

import { getEditingMessageAsync, editMessageAsync, clearMessageForm } from "../../../redux/actions/editMessage";
import { openCancelModal, closeCancelModal } from "../../../redux/actions/ui";

const mapStateToProps = state => ({
  ...state.editMessage,
  cancelModal: state.ui.cancelModal,
});

const mapDispatchToProps = dispatch => ({
  openCancelModal: () => dispatch(openCancelModal()),
  closeCancelModal: () => dispatch(closeCancelModal()),
  onGoBack: msgId => dispatch(push(`/message/${msgId}`)),
  editMessage: msgId => dispatch(editMessageAsync(msgId)),
  getMessageInfo: msgId => dispatch(getEditingMessageAsync(msgId)),
  clearForm: () => dispatch(clearMessageForm()),
});

class EditMessage extends Component {
  static propTypes = {
    ready: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    message: PropTypes.object.isRequired,
    onGoBack: PropTypes.func.isRequired,
    cancelModal: PropTypes.object.isRequired,
    openCancelModal: PropTypes.func.isRequired,
    closeCancelModal: PropTypes.func.isRequired,
    editMessage: PropTypes.func.isRequired,
    getMessageInfo: PropTypes.func.isRequired,
    clearForm: PropTypes.func.isRequired,
  };

  componentDidMount = () => {
    const { getMessageInfo } = this.props;
    const msgId = this.props.match.params.msgId;
    getMessageInfo(msgId);
  }

  /*
  askOrGoBack = () => {
    const { message, openCancelModal, onGoBack } = this.props;
    this.formIsEmpty(message) ? onGoBack() : openCancelModal();
  }
  */

  closeModalAndGo = () => {
    const { closeCancelModal, onGoBack, clearForm } = this.props;
    const msgId = this.props.match.params.msgId;
    closeCancelModal();
    clearForm();
    onGoBack(msgId);
  }


  render() {
    const { ready, loading, message, cancelModal, openCancelModal, closeCancelModal, editMessage } = this.props;

    return (
      <div className="page-wrapper">
        <Modal
          confirmText="Остаться"
          cancelText="Покинуть страницу"
          modal={cancelModal}
          onSubmit={() => closeCancelModal()}
          onCancel={() => this.closeModalAndGo()}
        />
        <div className="page-header">
          {ready ? (
            <button type="button" className="btn btn-back" onClick={() => openCancelModal()}>
              <i aria-hidden="true" className="back-icon icon" />
              <span>Назад</span> 
            </button>
          ) : false}
        </div>
        <div className="page-content forms">
          <div className="form-header">Редактирование сообщения</div>
          {ready ? (
            <MessageForm
              edit
              message={message}
              submitText="Сохранить изменения"
              onSubmit={() => editMessage(message.id)}
            />
          ) : false}
          {loading ? (<Spinner />) : false}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequireAuth(EditMessage));
